import styled from 'styled-components';

interface ContainerPropsType {
  $isGrid: boolean;
}

export const Container = styled.div<ContainerPropsType>`
  height: 100vh;
  .fc .fc-timegrid-slot-minor {
    border-top-color: ${(props) => (props.$isGrid ? 'var(--fc-border-color)' : 'transparent')};
  }
`;

export const CalendarContainer = styled.div`
  height: calc(100% - 60px);
`;

interface CalendarWrapperPropsType {
  $isLegend: boolean;
}

export const CalendarWrapper = styled.div<CalendarWrapperPropsType>`
  height: ${(props) => (props.$isLegend ? 'calc(100% - 50px)' : '100%')};
`;

export const LegendWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: var(--app-primary-background-color);
  width: 100vw;
  height: 50px;
  z-index: 100;
  overflow: scroll;
  box-sizing: border-box;
  padding: 0 1rem;
`;
